import { PageHeaderColorScheme } from "./interfaces";
export var PageHeaderDefaultProps = {
  colorScheme: PageHeaderColorScheme.Default,
  isFullWidth: false,
  hasShadow: false,
  isFixed: false,
  top: 0
};
export var PageHeaderButtonDefaultProps = {
  paddingHorizontal: 'S300',
  hasHover: true
};
export var PageHeaderLinkDefaultProps = {
  paddingHorizontal: 'S300',
  hasHover: true,
  isSelected: false
};
export var PAGE_HEADER_LINK_SELECTION_INDICATOR_HEIGHT = 4;